import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import './HomePage.css';

const SoportePage = () => {
  const navigate = useNavigate();

  // Redirigir automáticamente a /tareas-completar
  useEffect(() => {
    navigate('/tareas-completar', { replace: true });
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    navigate('/auth/login');
  };

  const links = [
    { to: '/home', label: 'Home' },
    { to: '/tareas-completar', label: 'Tareas a Completar' },
    { to: '/tareas-calificacion', label: 'Tareas por Calificación' },
    { to: '/auth/register', label: 'Crear Usuarios' },
    { to: '/admin/administrar-usuarios', label: 'Administrar Usuarios' }
  ];

  return (
    <div className="home-container">
      <Sidebar links={links} onLogout={handleLogout} />
      <main className="home-content">
        <h1>Panel de Soporte Técnico</h1>
        <p>Bienvenido al panel de soporte técnico. Desde aquí puedes gestionar usuarios del sistema.</p>
        
        <div className="buttons-container">
          <button 
            className="iphone-button btn-crear" 
            onClick={() => navigate('/tareas-completar')}
            style={{ backgroundColor: '#16a34a' }}
          >
            Tareas a Completar
          </button>
          <button 
            className="iphone-button btn-crear" 
            onClick={() => navigate('/auth/register')}
            style={{ backgroundColor: '#3c096c' }}
          >
            Crear Usuario
          </button>
          <button 
            className="iphone-button btn-crear" 
            onClick={() => navigate('/admin/administrar-usuarios')}
            style={{ backgroundColor: '#2b6cb0' }}
          >
            Administrar Usuarios
          </button>
        </div>
      </main>
    </div>
  );
};

export default SoportePage; 